<script>
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import { useVuelidate } from '@vuelidate/core';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';
import { FilterMatchMode, FilterService } from 'primevue/api';
import Service from '../../services/demurrage';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';

FilterService.register('onProductFn', (value, filterValue) => {
    if (!filterValue) return true;
    if (!Array.isArray(value)) return false;
    return value.some((item) => item.value === filterValue);
});

FilterService.register('onNoteFn', (value, filterNote) => {
    if (!filterNote) return true;
    if (!Array.isArray(value)) return false;
    const search = filterNote.toLowerCase();
    return value.some((item) => typeof item.note === 'string' && item.note.toLowerCase().includes(search));
});

FilterService.register('onCounterPartyRequestFn', (value, filterValue) => {
    if (filterValue === null || filterValue === undefined || filterValue === '') return true;
    if (!Array.isArray(value)) return false;
    return value.some((item) => item.request === Number(filterValue));
});

FilterService.register('onCheckboxFn', (value, filter) => {
    if (filter === true) {
        return value !== null && value !== 0;
    } else if (filter === false) {
        return value == null || value == 0 || value == '';
    }
    return true;
});

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: { ResponsiveButton, GenericCustomMasterDataAutocompleteV2 },
    data() {
        return {
            filters: {},
            previewDialog: false,
            noteDialog: false,
            counterPartyDialog: false,
            startDateRegister: null,
            noteDistinct: [],
            notesFiltered: [],
            newNote: {},
            newCounterPartyRequest: {},
            itemsHeader: [],
            itemsDetail: [],
            itemsRegister: null,
            editingItemsRegister: [],
            loading: false,
            exportExcelDialog: false,
            yearToExport: null,
            expandedRows: [],
        };
    },
    validations() {
        return {};
    },
    computed: {
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
    },
    created() {
        this.$store.dispatch('security/setNavbarTitle', this.$t('DemurrageRegister.page_title'));

        this.initFilters();
        this.getNoteDistinct();
    },
    mounted() {},
    methods: {
        loadRegister() {
            if (this.startDateRegister != null) {
                this.loading = true;
                const params = {
                    registerDate: Utils.formatDateForAPI(this.startDateRegister),
                };
                this.itemsRegister = [];
                Service.getRegister(params, (response) => {
                    this.loading = false;
                    if (response.success) {
                        this.itemsRegister = response.data;
                        this.formatDates();
                        this.expandedRows = this.itemsRegister.filter((x) => x.reasons && x.reasons.length > 0);
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
            } else {
                this.$toast.add({ detail: this.$t('DemurrageRegister.messages.error_entry_month'), life: 3000, severity: 'error' });
            }
        },

        checkStrEmpty(str) {
            return str === '' || str.trim().length === 0;
        },

        onAddNote(data) {
            const payload = {
                idDemurrageRegister: data.id,
                note: this.newNote[data.id] ? this.newNote[data.id] : '',
            };
            if (!this.checkStrEmpty(payload.note)) {
                this.$store.dispatch('generic/setLoading', true);
                Service.createNote(payload, (response) => {
                    if (response.success) {
                        this.newNote[data.id] = '';
                        this.loadRegisterById(data.id);
                        this.getNoteDistinct();
                        this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000 });
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
                this.$store.dispatch('generic/setLoading', false);
            } else {
                this.$toast.add({ detail: this.$t('DemurrageRegister.messages.error_valid'), life: 3000, severity: 'error' });
            }
        },

        onDeleteNote(idNote, idRegister) {
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch('generic/setLoading', true);
                    Service.deleteNote(idNote, (response) => {
                        this.$store.dispatch('generic/setLoading', false);
                        if (response.success) {
                            this.$confirm.close();
                            this.loadRegisterById(idRegister);
                            this.getNoteDistinct();
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000 });
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    this.$confirm.close();
                },
            });
        },

        onAddCounterPartyRequest(data) {
            const payload = {
                idDemurrageRegister: data.id,
                request: this.newCounterPartyRequest[data.id],
            };
            if (payload.request != null) {
                this.$store.dispatch('generic/setLoading', true);
                Service.createCounterPartyRequest(payload, (response) => {
                    if (response.success) {
                        this.newCounterPartyRequest[data.id] = null;
                        this.loadRegisterById(data.id);
                        this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000 });
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
                this.$store.dispatch('generic/setLoading', false);
            } else {
                this.$toast.add({ detail: this.$t('DemurrageRegister.messages.error_valid'), life: 3000, severity: 'error' });
            }
        },

        onDeleteCounterPartyRequest(idCounterPartyRequest, idRegister) {
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch('generic/setLoading', true);
                    Service.deleteCounterPartyRequest(idCounterPartyRequest, (response) => {
                        this.$store.dispatch('generic/setLoading', false);
                        if (response.success) {
                            this.$confirm.close();
                            this.loadRegisterById(idRegister);
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000 });
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    this.$confirm.close();
                },
            });
        },

        onRouteToDemurrageDetail(idMovementInstructionHeader) {
            this.$router.push(`/demurrage/calculator/` + idMovementInstructionHeader);
        },

        formatDates() {
            this.itemsRegister.forEach((item) => {
                item.referenceDate = item.referenceDate ? Utils.dateToCurrentTimeZone(item.referenceDate) : null;
                item.orderDate = item.orderDate ? Utils.dateToCurrentTimeZone(item.orderDate) : null;
                item.counterpartyOrderDate = item.counterpartyOrderDate ? Utils.dateToCurrentTimeZone(item.counterpartyOrderDate) : null;
                item.lastEstimatedDateBLCOD = item.lastEstimatedDateBLCOD ? Utils.dateToCurrentTimeZone(item.lastEstimatedDateBLCOD) : null;
                item.availableDateForClaimPresentation = item.availableDateForClaimPresentation ? Utils.dateToCurrentTimeZone(item.availableDateForClaimPresentation) : null;
            });
        },

        onShowPreview(id) {
            this.loadHeader(id);
            this.previewDialog = true;
        },

        loadRegisterById(id) {
            this.$store.dispatch('generic/setLoading', true);
            Service.getRegisterById(id, (response) => {
                if (response.success) {
                    const index = this.itemsRegister.findIndex((item) => item.id === id);
                    this.itemsRegister[index] = response.data;
                    this.formatRowDates(this.itemsRegister[index]);
                }
                this.$store.dispatch('generic/setLoading', false);
            });
        },

        formatHrsMins(value) {
            const absValue = Math.abs(value);
            const hrs = Math.floor(absValue / 60);
            const mins = absValue % 60;
            const sign = value < 0 ? '-' : '';
            return `${sign}${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
        },

        searchNote(event) {
            const query = event.query.toLowerCase();
            this.notesFiltered = this.noteDistinct.filter((note) => note.toLowerCase().includes(query));
        },

        initFilters() {
            this.filters = {
                registryPlant: { value: null, matchMode: FilterMatchMode.EQUALS },
                chargeDischargeFlag: { value: null, matchMode: FilterMatchMode.EQUALS },
                vesselName: { value: null, matchMode: FilterMatchMode.CONTAINS },
                voyageNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
                products: { value: null, matchMode: 'onProductFn' },
                demurrageRate: { value: null, matchMode: 'onCheckboxFn' },
                timeOnDemurrageRegister: { value: null, matchMode: 'onCheckboxFn' },
                timeOnDemurrageNet: { value: null, matchMode: 'onCheckboxFn' },
                totalDemurrageRegister: { value: null, matchMode: 'onCheckboxFn' },
                notes: { value: null, matchMode: 'onNoteFn' },
                totalDemurrageNet: { value: null, matchMode: 'onCheckboxFn' },
                counterpartyRequests: { value: null, matchMode: 'onCounterPartyRequestFn' },
                deltaDemurrage: { value: null, matchMode: 'onCheckboxFn' },
                agreedCode: { value: null, matchMode: FilterMatchMode.EQUALS },
                orderDate: { value: null, matchMode: FilterMatchMode.EQUALS },
                counterpartyOrderDate: { value: null, matchMode: FilterMatchMode.EQUALS },
                agreedValue: { value: null, matchMode: 'onCheckboxFn' },
                notAgreedValue: { value: null, matchMode: 'onCheckboxFn' },
                counterpartyPotentialValue: { value: null, matchMode: 'onCheckboxFn' },
                lastEstimatedDateBLCOD: { value: null, matchMode: FilterMatchMode.EQUALS },
                availableDateForClaimPresentation: { value: null, matchMode: FilterMatchMode.EQUALS },
                claimDelta: { value: null, matchMode: 'onCheckboxFn' },
                planningStrategy: { value: null, matchMode: FilterMatchMode.EQUALS },
            };
        },

        loadHeader(idMovementInstructionHeader) {
            this.$store.dispatch('generic/setLoading', true);
            Service.getCalculatorHeader(idMovementInstructionHeader, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    this.itemsHeader = response.data;
                    this.itemsHeader.totalDeductionsMinutes = this.formatHrsMins(this.itemsHeader.totalDeductionsMinutes);
                    this.itemsHeader.totalNetUsedtimeMinutes = this.formatHrsMins(this.itemsHeader.totalNetUsedtimeMinutes);
                    this.itemsHeader.timeOnDemurrageMinutes = this.formatHrsMins(this.itemsHeader.timeOnDemurrageMinutes);
                    this.loadDetail();
                }
            });
        },

        loadDetail() {
            this.$store.dispatch('generic/setLoading', true);
            Service.getCalculatorDetail(this.itemsHeader.id, (response) => {
                if (response.success) {
                    this.itemsDetail = response.data.filter((item) => item.isEntryActive == true);
                }
            });
            this.$store.dispatch('generic/setLoading', false);
        },

        onRegisterEditSave(data) {
            this.loading = true;
            Service.updateRegister(data, (response) => {
                if (response.success) {
                    this.loadRegisterById(data.id);
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
            this.loading = false;
        },

        onPlanningStrategySave(reason, data){
            this.loading = true;
            Service.updatePlanningStrategy(reason, (response) => {
                if (response.success) {
                    this.loadRegisterById(data.id);
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
            this.loading = false;
        },

        getNoteDistinct() {
            this.$store.dispatch('generic/setLoading', true);
            Service.getNoteDistinct((response) => {
                if (response.success) {
                    this.noteDistinct = response.data;
                }
            });
            this.$store.dispatch('generic/setLoading', false);
        },

        formatRowDates(data) {
            const rowData = data;
            rowData.orderDate = rowData.orderDate ? Utils.dateToCurrentTimeZone(rowData.orderDate) : null;
            rowData.counterpartyOrderDate = rowData.counterpartyOrderDate ? Utils.dateToCurrentTimeZone(rowData.counterpartyOrderDate) : null;
            rowData.lastEstimatedDateBLCOD = rowData.lastEstimatedDateBLCOD ? Utils.dateToCurrentTimeZone(rowData.lastEstimatedDateBLCOD) : null;
            rowData.availableDateForClaimPresentation = rowData.availableDateForClaimPresentation ? Utils.dateToCurrentTimeZone(rowData.availableDateForClaimPresentation) : null;
        },

        agreedClass(agreedCode) {
            return {
                'custom-green-cell  custom-cell': agreedCode === 'AGREED',
                'custom-red-cell custom-cell': agreedCode === 'NOT AGREED',
                'custom-blue-cell custom-cell': agreedCode === 'TIME EXPIRED. NO DEMURRAGE',
                'custom-yellow-cell custom-cell': agreedCode === 'ON DEMURRAGE. WAITING FOR CLAIM',
                'custom-cell': agreedCode != '',
            };
        },

        getLabelTriStateFilter(value) {
            return value == true ? this.$t('DemurrageRegister.valued') : value == false ? this.$t('DemurrageRegister.empty') : this.$t('DemurrageRegister.all');
        },

        onShowExportExcel() {
            this.yearToExport = this.startDateRegister;
            this.exportExcelDialog = true;
        },

        exportExcel() {
            if (this.yearToExport) {
                this.$store.dispatch('generic/setLoading', true);
                let fileNameWithExtension = this.yearToExport ? this.yearToExport.getFullYear() + '_Register_Summary.xlsx' : 'Register_Summary.xlsx';
                const params = {
                    year: this.yearToExport.getFullYear(),
                };
                Service.exportRegisterExcel(params, (response) => {
                    this.$store.dispatch('generic/setLoading', false);
                    if (response.success) {
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', fileNameWithExtension);
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        this.exportExcelDialog = false;
                    } else {
                        this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
            } else {
                this.$toast.add({ detail: this.$t('DemurrageRegister.messages.error_entry_year'), life: 3000, severity: 'error' });
            }
        },
        formatDecimal(n, digits, showZero) {
            if (!digits) {
                digits = 2;
            }
            if (n) {
                return n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
            }
            return showZero ? 0 : null;
        },

        getCurrencyAndUomLabel(currency, uom) {
            if (currency && uom) {
                return '(' + currency + '/' + uom + ')';
            } else {
                return (currency ? currency : '') + (uom ? uom : '');
            }
        },
    },
};
</script>

<template>
    <main>
        <Dialog v-model:visible="exportExcelDialog" :header="$t('DemurrageRegister.titleDialogExcel')" modal closable :style="{ width: '15vw' }">
            <div class="grid">
                <div class="col-12 lg:col-12 field">
                    <label>{{ $t('DemurrageRegister.yearToExport') }}</label>
                    <Calendar :class="{ 'p-inputtext-sm w-full': true }" placeholder="yyyy" view="year" dateFormat="yy" :showTime="false" v-model="yearToExport" :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                    <ResponsiveButton :label="$t('btn.download')" icon="pi pi-file-excel" @click="exportExcel()" class="w-full p-button p-button-sm p-button-success mt-4" />
                </div>
            </div>
        </Dialog>
        <Dialog v-model:visible="previewDialog" :header="$t('DemurrageRegister.titleDialogPreview')" modal closable :style="{ width: '50vw' }">
            <div class="grid">
                <div class="col-12 lg:col-12 field mt-2">
                    <DataTable :value="itemsDetail" showGridlines stripedRows :reorderableColumns="false">
                        <Column field="deductionDescription" :header="$t('DemurrageCalculator.reasons')" dataType="string">
                            <template #body="element">
                                {{ element.data.deductionDescription }}
                            </template>
                        </Column>

                        <Column field="dateFrom" :header="$t('DemurrageCalculator.from')" dataType="date">
                            <template #body="element">
                                {{ element.data.dateFrom != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.dateFrom)) : null }}
                            </template>
                        </Column>
                        <Column field="dateTo" :header="$t('DemurrageCalculator.to')" dataType="date">
                            <template #body="element">
                                {{ element.data.dateTo != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.dateTo)) : null }}
                            </template>
                        </Column>
                        <Column field="sharePercent" :header="$t('DemurrageCalculator.share')" dataType="number" style="width: 100px">
                            <template #body="element"> {{ element.data.sharePercent }} % </template>
                        </Column>
                        <Column field="totalMinutes" :header="$t('DemurrageCalculator.totalHoursMins')" dataType="string">
                            <template #body="element">
                                {{ this.formatHrsMins(element.data.totalMinutes) }}
                            </template>
                        </Column>
                        <Column field="totalHours" :header="$t('DemurrageCalculator.totalHours')" dataType="string">
                            <template #body="element">
                                {{ element.data.totalHours.toFixed(2) }}
                            </template>
                        </Column>
                        <template #empty>
                            {{ $t('noRecordsFound') }}
                        </template>
                    </DataTable>
                    <div class="grid formgrid pt-5">
                        <div class="col-12 field lg:col-3 lg:col-offset-6">
                            <label>{{ $t('DemurrageCalculator.totalDeductionMins') }}</label>
                            <InputText v-model="this.itemsHeader.totalDeductionsMinutes" readonly class="w-full p-inputtext-sm text-red" />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.totalDeduction') }}</label>
                            <InputText v-model="this.itemsHeader.totalDeductionsHours" readonly class="w-full p-inputtext-sm text-red" />
                        </div>

                        <div class="col-12 field lg:col-3 lg:col-offset-6">
                            <label>{{ $t('DemurrageCalculator.totalNetUsedTimeMins') }}</label>
                            <InputText v-model="this.itemsHeader.totalNetUsedtimeMinutes" readonly class="w-full p-inputtext-sm" />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.totalNetUsedTime') }}</label>
                            <InputNumber v-model="this.itemsHeader.totalNetUsedtimeHours" readonly class="w-full p-inputtext-sm" />
                        </div>

                        <div class="col-12 field lg:col-3 lg:col-offset-6">
                            <label>{{ $t('DemurrageCalculator.timeOnDemurrageMins') }}</label>
                            <InputText v-model="this.itemsHeader.timeOnDemurrageMinutes" readonly class="w-full p-inputtext-sm" />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.timeOnDemurrage') }}</label>
                            <InputNumber v-model="this.itemsHeader.timeOnDemurrageHours" readonly class="w-full p-inputtext-sm" />
                        </div>
                        <div class="col-12 field lg:col-3 lg:col-offset-9">
                            <label class="font-bold">{{ $t('DemurrageCalculator.total') }} {{ this.itemsHeader.demurrageCurrencyCode ? '(' + this.itemsHeader.demurrageCurrencyCode + ')' : '' }}</label>
                            <InputNumber v-model="this.itemsHeader.totalDemmurage" :minFractionDigits="2" :maxFractionDigits="2" mode="decimal" readonly class="w-full p-inputtext-sm" />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <div class="m-4">
            <div class="grid">
                <div class="col-12 lg:col-2 field">
                    <label>{{ $t('DemurrageRegister.month') }}</label>
                    <Calendar :class="{ 'p-inputtext-sm w-full': true }" placeholder="mm/yyyy" view="month" dateFormat="mm/yy" :showTime="false" v-model="startDateRegister" :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>
                <div class="col-12 lg:col-3 field m-4">
                    <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" @click="loadRegister" class="p-button p-button-sm m-3" />
                    <ResponsiveButton :label="$t('btn.download')" icon="pi pi-file-excel" @click="onShowExportExcel" class="p-button p-button-sm p-button-success m-3" />
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="col-12" style="height: calc(70vh)">
                <DataTable
                    v-model:filters="filters"
                    filterDisplay="row"
                    :value="itemsRegister"
                    scrollHeight="75vh"
                    showGridlines
                    stripedRows
                    scrollable
                    :responsiveLayout="'scroll'"
                    breakpoint="960px"
                    v-model:editingRows="editingItemsRegister"
                    editMode="cell"
                    dataKey="id"
                    size="small"
                    :loading="loading"
                >
                    <Column :exportable="false" style="min-width: 100px; max-width: 100px">
                        <template #body="slotProps">
                            <Button icon="pi pi-info-circle" class="p-button-rounded mr-2" v-tooltip="$t('DemurrageRegister.btn.detail')" @click="onRouteToDemurrageDetail(slotProps.data.idMovementInstructionHeader)" />
                            <Button icon="pi pi-eye" class="p-button-rounded p-button-outlined mr-2" v-tooltip="$t('DemurrageRegister.btn.preview')" @click="onShowPreview(slotProps.data.idMovementInstructionHeader)" />
                        </template>
                    </Column>

                    <Column field="referenceDate" :header="$t('DemurrageRegister.month')" style="max-width: 60px" sortable bodyStyle="text-align:left">
                        <template #body="{ data, field }">
                            <span> {{ data[field] != null ? utils.formatDateMonth(utils.dateToCurrentTimeZone(data[field])) : null }} </span>
                        </template>
                    </Column>

                    <Column field="registryPlant" :header="$t('DemurrageRegister.plant')" style="min-width: 150px; max-width: 150px" sortable :filter="true" :showFilterMenu="false" bodyStyle="text-align:left">
                        <template #filter="{ filterModel, filterCallback }">
                            <Dropdown
                                id="plant"
                                v-model="filterModel.value"
                                :options="[
                                    { value: 'S', label: 'ISAB SUD' },
                                    { value: 'N', label: 'ISAB NORD' },
                                ]"
                                optionLabel="label"
                                optionValue="value"
                                @change="filterCallback()"
                                class="w-full"
                            />
                        </template>
                    </Column>
                    <Column field="chargeDischargeFlag" :header="$t('DemurrageRegister.dischargeLifting')" style="min-width: 120px; max-width: 120px" sortable :filter="true" :showFilterMenu="false" bodyStyle="text-align:left">
                        <template #body="element">
                            {{ element.data.chargeDischargeFlag == 'D' ? $t('DemurrageRegister.discharge') : $t('DemurrageRegister.lifting') }}
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <Dropdown
                                id="chargeDischarge"
                                v-model="filterModel.value"
                                :options="[
                                    { value: 'D', label: $t('DemurrageRegister.discharge') },
                                    { value: 'C', label: $t('DemurrageRegister.lifting') },
                                ]"
                                optionLabel="label"
                                optionValue="value"
                                @change="filterCallback()"
                                class="w-full"
                            />
                        </template>
                    </Column>
                    <Column field="voyageNumber" :header="$t('DemurrageRegister.allocation')" style="min-width: 150px; max-width: 150px" sortable bodyStyle="text-align:left">
                        <template #filter="{ filterModel, filterCallback }">
                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column field="vesselName" :header="$t('DemurrageRegister.vesselName')" style="min-width: 150px; max-width: 150px" sortable bodyStyle="text-align:left">
                        <template #filter="{ filterModel, filterCallback }">
                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column field="products" :header="$t('DemurrageRegister.product')" style="min-width: 150px; max-width: 150px" sortable :filter="true" :showFilterMenu="false" filterMatchMode="onProductFn">
                        <template #body="element">
                            {{ element.data.products.map((p) => p.label).join(' + ') }}
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <GenericCustomMasterDataAutocompleteV2
                                :name="'products'"
                                :modelValue="{ value: filterModel.value }"
                                @update:modelValue="
                                    (val) => {
                                        filterModel.value = val;
                                        filterCallback();
                                    }
                                "
                                :format="{ label: 'label', value: 'value' }"
                                @change="filterCallback()"
                                api="masterdata/product-combo"
                                class="w-full p-inputtext-sm"
                            />
                        </template>
                    </Column>

                    <Column field="demurrageRate" :header="$t('DemurrageRegister.demurrageRate')" style="min-width: 150px; max-width: 150px" sortable :filter="true" :showFilterMenu="false" filterMatchMode="onCheckboxFn" bodyStyle="text-align:left">
                        <template #body="element">
                            {{ element.data.demurrageRate ? utils.formatDecimal(element.data.demurrageRate) + ' ' + getCurrencyAndUomLabel(element.data.demurrageCurrencyCode, element.data.demurrageUoMCode) : '' }}
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label>
                        </template>
                    </Column>

                    <Column
                        field="timeOnDemurrageRegister"
                        :header="$t('DemurrageRegister.timeOnDemurrage')"
                        style="min-width: 150px; max-width: 150px; padding: 0"
                        sortable
                        :filter="true"
                        :showFilterMenu="false"
                        filterMatchMode="onCheckboxFn"
                        bodyStyle="text-align:left"
                    >
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ formatDecimal(reason.timeOnDemurrageRegister / 60, 2, true) }}
                                            <span
                                                class="pl-1 pi pi-info-circle"
                                                v-if="reason.timeOnDemurrageCalculator !== null && reason.timeOnDemurrageCalculator !== 0 && reason.timeOnDemurrageRegister !== reason.timeOnDemurrageCalculator"
                                                v-tooltip="$t('DemurrageRegister.originalValue') + utils.formatDecimal(reason.timeOnDemurrageCalculator / 60)"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    {{ formatDecimal(element.data.timeOnDemurrageRegister / 60, 2, true) }}
                                    <span
                                        class="pl-1 pi pi-info-circle"
                                        v-if="element.data.timeOnDemurrageCalculator !== null && element.data.timeOnDemurrageCalculator !== 0 && element.data.timeOnDemurrageRegister !== element.data.timeOnDemurrageCalculator"
                                        v-tooltip="$t('DemurrageRegister.originalValue') + utils.formatDecimal(element.data.timeOnDemurrageCalculator / 60)"
                                    ></span>
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <div class="p-3">
                                <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                                <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label>
                            </div>
                        </template>
                    </Column>

                    <Column
                        field="timeOnDemurrageNet"
                        :header="$t('DemurrageRegister.timeOnDemurrageNetOftimeExpired')"
                        style="min-width: 150px; max-width: 150px; padding: 0"
                        sortable
                        :filter="true"
                        :showFilterMenu="false"
                        filterMatchMode="onCheckboxFn"
                        bodyStyle="text-align:left"
                    >
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ formatDecimal(reason.timeOnDemurrageNet / 60, 2, true) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    {{ formatDecimal(element.data.timeOnDemurrageNet / 60, 2, true) }}
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                                                        <div class="p-3">

                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label>
                                                        </div>
                        </template>
                    </Column>

                    <Column
                        field="totalDemurrageRegister"
                        :header="$t('DemurrageRegister.totalUsd')"
                        style="min-width: 150px; max-width: 150px; padding: 0"
                        sortable
                        :filter="true"
                        :showFilterMenu="false"
                        filterMatchMode="onCheckboxFn"
                        bodyStyle="text-align:left"
                    >
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ reason.totalDemurrageRegister ? formatDecimal(reason.totalDemurrageRegister, 2, true) + ' ' + (reason.demurrageCurrencyCode ? reason.demurrageCurrencyCode : '') : 0 }}
                                            <span
                                                class="pl-1 pi pi-info-circle"
                                                v-if="reason.totalDemurrageCalculator !== null && reason.totalDemurrageCalculator !== 0 && reason.totalDemurrageRegister !== reason.totalDemurrageCalculator"
                                                v-tooltip="$t('DemurrageRegister.originalValue') + utils.formatDecimal(reason.totalDemurrageCalculator)"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    {{ element.data.totalDemurrageRegister ? formatDecimal(element.data.totalDemurrageRegister, 2, true) + ' ' + (element.data.demurrageCurrencyCode ? element.data.demurrageCurrencyCode : '') : 0 }}
                                    <span
                                        class="pl-1 pi pi-info-circle"
                                        v-if="element.data.totalDemurrageCalculator !== null && element.data.totalDemurrageCalculator !== 0 && element.data.totalDemurrageRegister !== element.data.totalDemurrageCalculator"
                                        v-tooltip="$t('DemurrageRegister.originalValue') + utils.formatDecimal(element.data.totalDemurrageCalculator)"
                                    ></span>
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                                                        <div class="p-3">

                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label>
                                                        </div>
                        </template>
                    </Column>
<!-- 
                    <Column field="notes" :header="$t('DemurrageRegister.note')" style="min-width: 250px; max-width: 250px" class="pr-0" bodyStyle="text-align:right" :filter="true" filterMatchMode="onNoteFn" :showFilterMenu="false">
                        <template #body="slotProps">
                            <div class="grid w-full pt-2">
                                <div class="col-12" v-for="(item, index) in slotProps.data.notes" :key="index">
                                    <div class="grid pt-0 pb-0">
                                        <div class="field m-0 pt-0 pb-0" :class="{ 'col-12': !uiPermissions('DemurrageRegisterUI').isEnabled, 'col-10': uiPermissions('DemurrageRegisterUI').isEnabled }">
                                            <InputText readonly v-model="item.note" class="w-full" />
                                        </div>
                                        <div class="col-2 field m-0 pt-0 pb-0" v-if="uiPermissions('DemurrageRegisterUI').isEnabled">
                                            <ResponsiveButton icon="pi pi-trash" @click="onDeleteNote(item.id, slotProps.data.id)" class="p-button-sm p-button-error" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 pt-2 pb-0" v-if="uiPermissions('DemurrageRegisterUI').isEnabled">
                                    <div class="grid pt-1 pb-0">
                                        <div class="col-10 lg:col-10 field m-0 pt-1 pb-0">
                                            <AutoComplete :inputStyle="{ width: '100%' }" dropdown v-model="newNote[slotProps.data.id]" :suggestions="notesFiltered" @complete="searchNote" class="w-full p-inputtext-sm" />
                                        </div>
                                        <div class="col-2 lg:col-2 field m-0 pt-1 pb-0">
                                            <ResponsiveButton icon="pi pi-plus" class="p-button-sm p-button-success" @click="onAddNote(slotProps.data)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" />
                        </template>
                    </Column>
                                        -->

                    <Column field="notes2" :header="$t('DemurrageRegister.note')" style="min-width: 250px; max-width: 250px; padding: 0" class="pr-0" bodyStyle="text-align:right">
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ reason.notes[0].note }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Column>

                    <Column field="notes3" :header="$t('DemurrageRegister.extendedNote')" style="min-width: 250px; max-width: 250px; padding: 0" class="pr-0" bodyStyle="text-align:right">
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ reason.notes[0].note }} {{ reason.notes[0].extendedNote ? '('+reason.notes[0].extendedNote+')' : '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column
                        field="totalDemurrageNet"
                        :header="$t('DemurrageRegister.netOfTimeEXpired')"
                        style="min-width: 150px; max-width: 150px; padding: 0"
                        bodyStyle="text-align:left"
                        :filter="true"
                        :showFilterMenu="false"
                        filterMatchMode="onCheckboxFn"
                    >
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            <div v-if="reason.totalDemurrageNet">
                                                {{ reason.totalDemurrageNet ? utils.formatDecimal(reason.totalDemurrageNet) + ' ' + (reason.demurrageCurrencyCode ? reason.demurrageCurrencyCode : '') : 0 }}
                                            </div>
                                            <span v-else> {{ reason.totalDemurrageNetString }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    <div v-if="element.data.totalDemurrageNet">
                                        {{ element.data.totalDemurrageNet ? utils.formatDecimal(element.data.totalDemurrageNet) + ' ' + (element.data.demurrageCurrencyCode ? element.data.demurrageCurrencyCode : '') : 0 }}
                                    </div>
                                    <span v-else> {{ element.data.totalDemurrageNetString }}</span>
                                </div>
                            </div>
                        </template>

                        <template #filter="{ filterModel, filterCallback }">
                                                        <div class="p-3">

                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label></div>
                        </template>
                    </Column>

                    <Column
                        field="counterpartyRequests"
                        :header="$t('DemurrageRegister.counterpartyRequest')"
                        style="min-width: 250px; max-width: 250px"
                        bodyStyle="text-align:right"
                        :filter="true"
                        filterMatchMode="onCounterPartyRequestFn"
                        :showFilterMenu="false"
                    >
                        <template #body="slotProps">
                            <div class="grid w-full pt-2">
                                <div class="col-12" v-for="(item, index) in slotProps.data.counterpartyRequests" :key="index">
                                    <div class="grid pt-0 pb-0">
                                        <div class="field m-0 pt-0 pb-0" :class="{ 'col-12': !uiPermissions('DemurrageRegisterUI').isEnabled, 'col-10': uiPermissions('DemurrageRegisterUI').isEnabled }">
                                            <InputNumber
                                                readonly
                                                v-model="item.request"
                                                class="w-full"
                                                mode="decimal"
                                                :minFractionDigits="2"
                                                :maxFractionDigits="2"
                                                :suffix="slotProps.data.demurrageCurrencyCode ? ' ' + slotProps.data.demurrageCurrencyCode : ' '"
                                            />
                                        </div>
                                        <div class="col-2 field m-0 pt-0 pb-0" v-if="uiPermissions('DemurrageRegisterUI').isEnabled">
                                            <ResponsiveButton icon="pi pi-trash" @click="onDeleteCounterPartyRequest(item.id, slotProps.data.id)" class="p-button-sm p-button-error" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 pt-2 pb-0" v-if="uiPermissions('DemurrageRegisterUI').isEnabled">
                                    <div class="grid pt-1 pb-0">
                                        <div class="col-10 field m-0 pt-1 pb-0">
                                            <InputNumber
                                                :inputStyle="{ width: '100%' }"
                                                mode="decimal"
                                                :minFractionDigits="2"
                                                :maxFractionDigits="2"
                                                v-model="newCounterPartyRequest[slotProps.data.id]"
                                                class="w-full"
                                                :suffix="slotProps.data.demurrageCurrencyCode ? ' ' + slotProps.data.demurrageCurrencyCode : ' '"
                                            />
                                        </div>
                                        <div class="col-2 field m-0 pt-1 pb-0">
                                            <ResponsiveButton icon="pi pi-plus" class="p-button-sm p-button-success" @click="onAddCounterPartyRequest(slotProps.data)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <InputNumber
                                :modelValue="filterModel.value"
                                @update:modelValue="
                                    (val) => {
                                        filterModel.value = val;
                                        filterCallback();
                                    }
                                "
                                mode="decimal"
                                :minFractionDigits="2"
                                :maxFractionDigits="2"
                                class="p-column-filter"
                            />
                        </template>
                    </Column>

                    <Column field="counterpartyRequests2" :header="$t('DemurrageRegister.counterpartyRequest')" style="min-width: 250px; max-width: 250px; padding: 0" class="pr-0" bodyStyle="text-align:right">
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ reason.counterpartyRequests ? (reason.counterpartyRequests[0].request ? utils.formatDecimal(reason.counterpartyRequests[0].request) : 0) + ' ' + element.data.demurrageCurrencyCode : '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Column>

                    <Column
                        field="deltaDemurrage"
                        :header="$t('DemurrageRegister.delta')"
                        bodyStyle="text-align:left"
                        style="min-width: 150px; max-width: 150px; padding: 0"
                        sortable
                        :filter="true"
                        :showFilterMenu="false"
                        filterMatchMode="onCheckboxFn"
                    >
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 && reason.deltaDemurrage ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ reason.deltaDemurrage ? utils.formatDecimal(reason.deltaDemurrage) : '' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    {{ element.data.deltaDemurrage ? utils.formatDecimal(element.data.deltaDemurrage) : '' }}
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                                                        <div class="p-3">

                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label></div>
                        </template>
                    </Column>

                    <Column field="agreedCode" :header="$t('DemurrageRegister.agreedNotAgreed')" style="min-width: 200px; max-width: 200px" sortable :filter="true" :showFilterMenu="false">
                        <template #body="slotProps">
                            <div :class="agreedClass(slotProps.data.agreedCode)" style="padding: 0.5rem">
                                {{ slotProps.data.agreedCode }}
                            </div>
                        </template>

                        <template #filter="{ filterModel, filterCallback }">
                            <Dropdown
                                id="agreed"
                                v-model="filterModel.value"
                                :options="[
                                    { value: 'AGREED', label: 'AGREED' },
                                    { value: 'NOT AGREED', label: 'NOT AGREED' },
                                    { value: 'TIME EXPIRED. NO DEMURRAGE', label: 'TIME EXPIRED. NO DEMURRAGE' },
                                    { value: 'ON DEMURRAGE. WAITING FOR CLAIM', label: 'ON DEMURRAGE. WAITING FOR CLAIM' },
                                    { value: 'NO DEMURRAGE', label: 'NO DEMURRAGE' },
                                ]"
                                optionLabel="label"
                                optionValue="value"
                                @change="filterCallback()"
                                class="w-8rem"
                            />
                        </template>
                    </Column>

                    <Column field="orderDate" :header="$t('DemurrageRegister.dateOrder')" bodyStyle="text-align:left" style="min-width: 150px; max-width: 150px" sortable dataType="date" :filter="true">
                        <template #body="{ data, field }">
                            <Calendar
                                :readonly="!uiPermissions('DemurrageRegisterUI').isEnabled"
                                class="w-full"
                                v-model="data[field]"
                                @date-select="onRegisterEditSave(data)"
                                appendTo="body"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showButtonBar="true"
                                :yearNavigator="true"
                            />
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <Calendar
                                class="w-full"
                                v-model="filterModel.value"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                mask="99/99/9999"
                                @keydown.enter="filterCallback()"
                                @date-select="filterCallback()"
                                :showButtonBar="true"
                                :yearNavigator="true"
                            />
                        </template>
                    </Column>

                    <Column field="counterpartyOrderDate" :header="$t('DemurrageRegister.dateInvoiceCounterparty')" bodyStyle="text-align:left" style="min-width: 150px; max-width: 150px" sortable dataType="date" :filter="true">
                        <template #body="{ data, field }">
                            <Calendar
                                :readonly="!uiPermissions('DemurrageRegisterUI').isEnabled"
                                class="w-full"
                                v-model="data[field]"
                                @date-select="onRegisterEditSave(data)"
                                appendTo="body"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showButtonBar="true"
                                :yearNavigator="true"
                            />
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <Calendar
                                class="w-full"
                                v-model="filterModel.value"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                mask="99/99/9999"
                                @keydown.enter="filterCallback()"
                                @date-select="filterCallback()"
                                :showButtonBar="true"
                                :yearNavigator="true"
                            />
                        </template>
                    </Column>

                    <Column
                        field="agreedValue"
                        :header="$t('DemurrageRegister.agreedValue')"
                        bodyStyle="text-align:left"
                        style="min-width: 150px; max-width: 150px; padding: 0"
                        sortable
                        :filter="true"
                        :showFilterMenu="false"
                        filterMatchMode="onCheckboxFn"
                    >
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 && reason.agreedValue ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ reason.agreedValue ? utils.formatDecimal(reason.agreedValue) + (element.data.demurrageCurrencyCode ? ' ' + element.data.demurrageCurrencyCode : '') : '' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    {{ element.data.agreedValue ? utils.formatDecimal(element.data.agreedValue) + (element.data.demurrageCurrencyCode ? ' ' + element.data.demurrageCurrencyCode : '') : ' ' }}
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                                                        <div class="p-3">

                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label></div>
                        </template>
                    </Column>

                    <Column
                        field="notAgreedValue"
                        :header="$t('DemurrageRegister.pendingValue')"
                        bodyStyle="text-align:left"
                        style="min-width: 150px; max-width: 150px; padding: 0"
                        sortable
                        :filter="true"
                        :showFilterMenu="false"
                        filterMatchMode="onCheckboxFn"
                    >
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 && reason.notAgreedValue ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ reason.notAgreedValue ? utils.formatDecimal(reason.notAgreedValue) + (element.data.demurrageCurrencyCode ? ' ' + element.data.demurrageCurrencyCode : '') : '' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    {{ element.data.notAgreedValue ? utils.formatDecimal(element.data.notAgreedValue) + (element.data.demurrageCurrencyCode ? ' ' + element.data.demurrageCurrencyCode : '') : '' }}
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">                            <div class="p-3">

                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label></div>
                        </template>
                    </Column>

                    <Column
                        field="counterpartyPotentialValue"
                        :header="$t('DemurrageRegister.poteintialClaim')"
                        bodyStyle="text-align:left"
                        style="min-width: 150px; max-width: 150px; padding: 0"
                        sortable
                        :filter="true"
                        :showFilterMenu="false"
                        filterMatchMode="onCheckboxFn"
                    >
                        <template #body="element">
                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="element.data.reasons && element.data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in element.data.reasons" :style="index < element.data.reasons.length - 1 && reason.counterpartyPotentialValue ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            {{ reason.counterpartyPotentialValue }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    {{ element.data.counterpartyPotentialValue }}
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">                            <div class="p-3">

                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label></div>
                        </template>
                    </Column>

                    <Column field="lastEstimatedDateBLCOD" :header="$t('DemurrageRegister.lastEstimedDateOfBLOrCOD')" bodyStyle="text-align:left" style="min-width: 150px; max-width: 150px" sortable dataType="date" :filter="true">
                        <template #body="{ data, field }">
                            <Calendar
                                :readonly="!uiPermissions('DemurrageRegisterUI').isEnabled"
                                class="w-full"
                                v-model="data[field]"
                                @date-select="onRegisterEditSave(data)"
                                appendTo="body"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showButtonBar="true"
                                :yearNavigator="true"
                            />
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <Calendar
                                class="w-full"
                                v-model="filterModel.value"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                mask="99/99/9999"
                                @keydown.enter="filterCallback()"
                                @date-select="filterCallback()"
                                :showButtonBar="true"
                                :yearNavigator="true"
                            />
                        </template>
                    </Column>

                    <Column field="availableDateForClaimPresentation" :header="$t('DemurrageRegister.availableTimeForClaimPresentation')" bodyStyle="text-align:left" style="min-width: 150px; max-width: 150px" sortable dataType="date" :filter="true">
                        <template #body="{ data, field }">
                            <Calendar
                                :readonly="!uiPermissions('DemurrageRegisterUI').isEnabled"
                                class="w-full"
                                v-model="data[field]"
                                @date-select="onRegisterEditSave(data)"
                                appendTo="body"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showButtonBar="true"
                                :yearNavigator="true"
                            />
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <Calendar
                                class="w-full"
                                v-model="filterModel.value"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                mask="99/99"
                                @keydown.enter="filterCallback()"
                                @date-select="filterCallback()"
                                :showButtonBar="true"
                                :yearNavigator="true"
                            />
                        </template>
                    </Column>

                    <Column field="claimDelta" :header="$t('DemurrageRegister.delta')" bodyStyle="text-align:left" style="min-width: 150px; max-width: 150px" sortable :filter="true" :showFilterMenu="false" filterMatchMode="onCheckboxFn">
                        <template #filter="{ filterModel, filterCallback }">
                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                            <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label>
                        </template>
                    </Column>

                    <Column field="planningStrategy" :header="$t('DemurrageRegister.planningStrategy')" bodyStyle="text-align:left" style="min-width: 100px; max-width: 100px" sortable :filter="true" :showFilterMenu="false">
                        <template #body="{ data, field }">

                            <div class="grid w-full cell-vertical-align">
                                <div class="col-12" v-if="data.reasons && data.reasons.length > 0">
                                    <div class="grid">
                                        <div class="col-12" v-for="(reason, index) in data.reasons" :style="index < data.reasons.length - 1 ? 'border-bottom: 1px solid #e9ecef' : ''" :key="index">
                                            <Dropdown
                                                :disabled="!uiPermissions('DemurrageRegisterUI').isEnabled"
                                                id="planningStrategy"
                                                v-model="reason.planningStrategy"
                                                :options="[
                                                    { value: true, label: $t('yes') },
                                                    { value: false, label: $t('no') },
                                                ]"
                                                optionLabel="label"
                                                optionValue="value"
                                                class="w-full"
                                                @change="onPlanningStrategySave(reason, data)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-else>
                                    <Dropdown
                                        :disabled="!uiPermissions('DemurrageRegisterUI').isEnabled"
                                        id="planningStrategy"
                                        v-model="data[field]"
                                        :options="[
                                            { value: true, label: $t('yes') },
                                            { value: false, label: $t('no') },
                                        ]"
                                        optionLabel="label"
                                        optionValue="value"
                                        class="w-full"
                                        @change="onRegisterEditSave(data)"
                                    />
                                </div>
                            </div>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <Dropdown
                                v-model="filterModel.value"
                                :options="[
                                    { value: true, label: $t('yes') },
                                    { value: false, label: $t('no') },
                                ]"
                                optionLabel="label"
                                optionValue="value"
                                @change="filterCallback()"
                                class="w-full"
                            />
                        </template>
                    </Column>

                    <template #empty>
                        {{ $t('noRecordsFound') }}
                    </template>
                </DataTable>
                <div class="align-right pr-8 pt-2 pb-4"></div>
            </div>
        </div>
    </main>
</template>

<style scoped>
.align-right {
    display: flex;
    justify-content: flex-end;
}

.custom-green-cell {
    background-color: #00a738 !important;
    color: #ffffff !important;
    border-radius: 0.25rem;
}

.custom-red-cell {
    background-color: #fc0000 !important;
    color: #ffffff !important;
    border-radius: 0.25rem;
}

.custom-blue-cell {
    background-color: #5e69f5 !important;
    color: #ffffff !important;
    border-radius: 0.25rem;
}

.custom-yellow-cell {
    background-color: #fbff05 !important;
    color: rgb(90, 55, 1) !important;
    border-radius: 0.25rem;
}

.custom-cell {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-weight: bold;
}

::v-deep(.p-datatable-row-expansion > td) {
    padding-right: 0 !important;
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    border: none !important;
}
</style>
